import { Box, CircularProgress, Tooltip } from '@vapor/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLanguage } from '@fortawesome/free-solid-svg-icons'
import { useMemo } from 'react'

export const MultiLanguagesButton = (props: { loading: boolean; handleOnClick?: (p?: any) => void; tooltip?: string }) => {
  const button = useMemo(() => {
    return (
      <Box flex="0 0 auto" sx={{ fontSize: '1.2rem', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
        {props.loading ? <CircularProgress size={18} sx={{ color: 'white' }} /> : <FontAwesomeIcon icon={faLanguage} />}
      </Box>
    )
  }, [props.loading])
  return (
    <i onClick={props.handleOnClick}>
      {props.tooltip ? (
        <Tooltip title={props.tooltip}>
          <div>{button}</div>
        </Tooltip>
      ) : (
        button
      )}
    </i>
  )
}

export default MultiLanguagesButton
